import { EventType } from "@/types";

import { axios } from "../axios.instance";

export type CreateDateNightRequest = Pick<EventType, "title" | "description" | "location" | "date">;

export type CreateDateNightResponse = EventType;

export const createDateNight = async (body: CreateDateNightRequest): Promise<CreateDateNightResponse> => {
  const { data } = await axios.post(`/events/date-nights/create`, body);

  return data;
};
